import { NavLink } from "react-router-dom";
import { MobileNav } from "./MobileNav.styled";
import data from "assets/data/data.json";

interface MobileNavProps {
  showHideMobile: (bool: boolean) => void;
}


function MobileNavmenu({showHideMobile}: MobileNavProps) {
  const closeNavmenu = () => showHideMobile(false);

  return (
    <MobileNav>
      <ul>
        {data.routes.map((route, idx) => {        
          return <li key={idx}><NavLink to={route.path} onClick={closeNavmenu}>{route.name}</NavLink></li>;
        })}
      </ul>
    </MobileNav>
  );
}

export default MobileNavmenu;
